import { Repository } from './Repository';

export default class AiRepository extends Repository {
    constructor() {
        super();

        this.aiRequestPrefix = '/api/v1/ai';
    }

    getImage = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/img${url}`);
    }

    getTTS = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/tts${url}`);
    }

    getTTSWithAzure = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/tts-azure${url}`);
    }

    getTTSWithGoogle = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/tts-google${url}`);
    }

    getTranslate = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/translate${url}`);
    }

    getSentence = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/sentence${url}`);
    }

    getWords = (url) => {
        return this.getRequestPromise('get', this.aiRequestPrefix + `/words${url}`);
    }
}
